import { render, staticRenderFns } from "./sendCode.vue?vue&type=template&id=cb0274c8&scoped=true"
import script from "./sendCode.vue?vue&type=script&lang=js"
export * from "./sendCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0274c8",
  null
  
)

export default component.exports